import { router } from 'expo-router';
import React from 'react';
import { toast } from 'sonner';

import { useIsLoadingUserData, useUser } from '@/states/auth';

type RoleHandlerProps = {
  children: React.ReactNode;
  type?: 'basic-user';
};

export const RoleHandler: React.FC<RoleHandlerProps> = React.memo(
  ({ children, type = 'basic-user' }) => {
    const user = useUser();
    const isLoadingUserData = useIsLoadingUserData();

    if (isLoadingUserData) {
      return null;
    }

    if (user && type === 'basic-user') {
      return <>{children}</>;
    }

    // it means there is no user. redirect to demos page and show a toast
    toast.info("You don't have access to this page", {
      description: 'If you think this is an error, please contact support',
      duration: 5000,
    });
    router.push('/demos');
    return null;
  }
);

export const withRoleHandler = <T,>(Component: React.ComponentType<T>) => {
  return (props: any) => (
    <RoleHandler type="basic-user">
      <Component {...props} />
    </RoleHandler>
  );
};
